import { getCardDate } from '@terminal/utils/card-utils/card-utils';
import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './InsightFeedCard.module.scss';

export enum CardType {
  CompanyCatalyst,
  MarketCatalyst,
  MarketSummary,
  Scenario,
  EarningsPreview,
  EarningsRecap,
}

export interface InsightFeedCardProps {
  className?: string;
  headerContent: ReactNode;
  cardTitle: ReactNode;
  description: ReactNode;
  leftNode?: ReactNode;
  onClick?: () => void;
  date?: Date;
  variant?: 'default' | 'secondary';
}

export const InsightFeedCard = ({
  className,
  headerContent,
  cardTitle,
  description,
  leftNode,
  onClick,
  date,
  variant = 'default',
}: InsightFeedCardProps) => {
  const cardDate = date ?? new Date();
  const isDefault = variant === 'default';

  return (
    <div
      className={clsx(
        styles.root,
        isDefault && styles.defaultVariant,
        className
      )}
      data-testid="insight-feed-card"
      onClick={onClick}
    >
      <div className={styles.flexWrapper}>
        {leftNode}
        <div className={styles.content}>
          <div className={styles.headerWrapper}>{headerContent}</div>
          {cardTitle}
          <div className={styles.footerWrapper}>
            <div className={styles.description}>{description}</div>
            <span className={styles.dateLabel}>{getCardDate(cardDate)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
